export default {
    book: 'Резервирај {product}',
    age_limit: 'Само за над {age} години',
    change_plan: 'Промени план',
    upgrade_product: 'Надгради производ',
    upgrade: 'Надгради',
    cancel_upgrade: 'Откажи надградба',
    choose_product: 'Избери {product}',
    days: '{count} ден | {count} дена',
    login_register: 'Најави се/Регистрирај се',
    current: 'Тековно',
    keyless_benefits: {
        label: 'Директно до возилото {0}',
        highlight: 'услуга за изнајмување™',
        list: {
            cant_lose_the_key: 'Целосно осигурување',
            zero_excess: 'Без вишок',
            phone_as_a_key: 'Телефон како клуч',
            straight_to_car: 'Без чекање',
            no_queues: 'Без редици',
            online_id_check: 'Онлајн проверка на идентитет',
            self_checkout: 'Самостојна наплата',
        },
    },
};
